/**
 * @author Erik Haßlmeyer <erik.hasslmeyer@refinio.net>
 * @copyright REFINIO GmbH 2022
 * @license CC-BY-NC-SA-2.5; portions MIT License
 * @version 0.0.1
 */
import { ensurePublicKey } from '../crypto/encryption.js';
import { ensurePublicSignKey } from '../crypto/sign.js';
import { getObject, storeUnversionedObject } from '../storage-unversioned-objects.js';
import { hexToUint8Array, uint8arrayToHexString } from '../util/arraybuffer-to-and-from-hex-string.js';
/**
 * Stores the public part of the keys.
 *
 * @param {SHA256IdHash<Person | Instance>} owner
 * @param {PublicKey} publicEncryptionKey
 * @param {PublicSignKey} publicSignKey
 * @returns {Promise<UnversionedObjectResult<Keys>>}
 */
export async function storePublicKeys(owner, publicEncryptionKey, publicSignKey) {
    return storeUnversionedObject({
        $type$: 'Keys',
        owner: owner,
        publicKey: uint8arrayToHexString(publicEncryptionKey),
        publicSignKey: uint8arrayToHexString(publicSignKey)
    });
}
/**
 * Get the public keys from the Keys object.
 *
 * @param {SHA256Hash<Keys>} keysObjHash
 * @returns {Promise<{publicEncryptionKey: PublicKey, publicSignKey: PublicSignKey}>}
 */
export async function getPublicKeys(keysObjHash) {
    const keysObj = await getObject(keysObjHash);
    return {
        publicEncryptionKey: ensurePublicKey(hexToUint8Array(keysObj.publicKey)),
        publicSignKey: ensurePublicSignKey(hexToUint8Array(keysObj.publicSignKey))
    };
}
//# sourceMappingURL=key-storage-public.js.map